import { axiosInstance } from "../../../../Services";

export const addCardLabel = async (cardId, label) => {
    try {
      const res = await axiosInstance.put(
        `/mmhboard/cards/label/${cardId}/add`,
        { labels: label },
      );
      return res;
    } catch (error) {
      throw error;
    }
  };
  
  export const removeCardLabel = async (cardId, title) => {
    try {
      const res = await axiosInstance.put(
        `/mmhboard/cards/label/${cardId}/remove`,
        { title },
      );
      return res;
    } catch (error) {
      throw error;
    }
  };
  